import {PersonModel} from '../../model'
import {aditionalValues} from '../../../../util/utilitario'
export const initValues: PersonModel = {
  id: '',
  tipoDocumento: '',
  numeroDocumento: '',
  email: '',
  celular: '',
  telefono: '',
  telefono2: '',
  estado: '',
  fechaNacimiento: '',
  nombres: '',
  apellidoPaterno: '',
  apellidoMaterno: '',
  sexoId: '',
  nacionalidadId: '',
  ...aditionalValues,
}
